"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActualRouteBreadcrumbUpdate = exports.ActualRouteBreadcrumbCreate = exports.ActualRouteBreadcrumbQuery = exports.ActualRouteBreadcrumbPrimary = exports.ActualRouteBreadcrumbTransport = exports.ActualRouteBreadcrumb = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const RouteEvent_1 = require("./RouteEvent");
exports.ActualRouteBreadcrumb = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    // event: Type.Optional(RouteEvent),
    eventID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    // routePlan: DailyRoutePlan,
    routePlanID: typebox_1.Type.String({ format: 'uuid' }),
    // plannedStop: RoutePlanStop,
    plannedStopID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    latitude: typebox_1.Type.Number(),
    longitude: typebox_1.Type.Number(),
    timestamp: typebox_1.Type.String({ format: 'date-time' }),
});
exports.ActualRouteBreadcrumbTransport = exports.ActualRouteBreadcrumb;
exports.ActualRouteBreadcrumbPrimary = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.ActualRouteBreadcrumb, ['eventID']),
    typebox_1.Type.Object({
        event: typebox_1.Type.Optional(RouteEvent_1.RouteEvent),
    }),
]);
exports.ActualRouteBreadcrumbQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        routePlanID: typebox_1.Type.String({ format: 'uuid' }),
        plannedStopID: typebox_1.Type.String({ format: 'uuid' }),
        latitudeAbove: typebox_1.Type.Number(),
        latitudeBelow: typebox_1.Type.Number(),
        longitudeAbove: typebox_1.Type.Number(),
        longitudeBelow: typebox_1.Type.Number(),
        timestampBefore: typebox_1.Type.String({ format: 'date-time' }),
        timestampAfter: typebox_1.Type.String({ format: 'date-time' }),
        hasEvent: typebox_1.Type.Boolean(),
        subscriptionID: typebox_1.Type.String({ format: 'uuid' }),
    }),
]));
exports.ActualRouteBreadcrumbCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.ActualRouteBreadcrumb, ['id', 'haulerID', 'eventID', 'timestamp']),
    typebox_1.Type.Object({
        event: typebox_1.Type.Optional(RouteEvent_1.RouteEventCreate),
        timestamp: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time', description: 'If not provided, will default to the current date and time' })),
    }),
]);
exports.ActualRouteBreadcrumbUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.ActualRouteBreadcrumb, ['id', 'haulerID', 'eventID']),
    typebox_1.Type.Object({
        event: (0, common_1.Nullable)(RouteEvent_1.RouteEventUpdate),
    }),
]));
//# sourceMappingURL=ActualRouteBreadcrumb.js.map